module.exports = __webpack_public_path__ + "static/media/scarecrow.9635a4b2.svg";